import { Component } from '@angular/core';
@Component({
  selector: 'app-secure-zone-authoring-tools',
  templateUrl: './secure-zone-authoring-tools.component.html',
  styleUrls: ['./secure-zone-authoring-tools.component.scss']
})
export class SecureZoneAuthoringToolsComponent {
     constructor() {}
     sidebarActive: boolean = true;
}
